import 'angular-bootstrap-toggle/src/angular-bootstrap-toggle';
import 'angular-moment';
import 'angular-ui-bootstrap';
import 'ob-daterangepicker/dist/scripts/ob-daterangepicker';
import BootstrapSettings from './bootstrap/bootstrap';
import Breadcrumbs from './breadcrumbs/breadcrumbs';
import BrowserCheck from './browser-check/browser-check';
import ClientSelector from './client-selector/client-selector';
import CommonRequest from './common-request/common-request';
import CurrentUser from './current-user/current-user';
import CustomDropdown from './custom-dropdown/custom-dropdown';
import CustomTypeahead from './custom-typeahead/custom-typeahead';
import DateInput from './date-input/date-input';
import DateRange from './date-range/date-range';
import DatetimeHelper from './datetime-helper/datetime-helper';
import DirectionNavigator from './direction-navigator/direction-navigator';
import FacilitySettings from './facility-settings/facility-settings';
import FormFields from './form-fields/form-fields';
import Header from './header/header';
import ListHeader from './list-header/list-header';
import MonthNavigator from './month-navigator/month-navigator';
import MonthlyReporting from './monthly-reporting/monthly-reporting';
import NumberMaxlength from './directives/number-maxlength';
import NumbersOnly from './directives/numbers-only';
import PageTitle from './page-title/page-title';
import Paginator from './paginator/paginator';
import ReportClientSelector from './report-client-selector/report-client-selector';
import ReportGridSquare from './report-grid-square/report-grid-square';
import TimeoutWarning from './timeout-warning/timeout-warning';
import UserHelper from './user-helper/user-helper';
import Utils from './utils/utils';

const components = angular
    .module('Common', [
        'angularMoment',
        'obDateRangePicker',
        'ui.bootstrap',
        'ui.toggle',
        BootstrapSettings,
        Breadcrumbs,
        BrowserCheck,
        ClientSelector,
        CommonRequest,
        CurrentUser,
        CustomDropdown,
        CustomTypeahead,
        DateInput,
        DateRange,
        DatetimeHelper,
        DirectionNavigator,
        FacilitySettings,
        FormFields,
        Header,
        ListHeader,
        MonthNavigator,
        MonthlyReporting,
        NumberMaxlength,
        NumbersOnly,
        PageTitle,
        Paginator,
        ReportClientSelector,
        ReportGridSquare,
        TimeoutWarning,
        UserHelper,
        Utils
    ])
    .name;

export default components;



// WEBPACK FOOTER //
// ./app/common/common.js